import WithFormContext from "../../containers/WithFormContextComponent";
import Button from "./Button";

export default WithFormContext(Button);
